// extracted by mini-css-extract-plugin
export default {"btn-override":"Checkbox_style_btn-override__Ru61w","checkbox":"Checkbox_style_checkbox__eA24l","rotate":"Checkbox_style_rotate__iwuV3"};